module.exports = __webpack_public_path__ + "img/how_electricity_work_splash.fb124790.jpg";